import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteMachineApi } from "../../services/machine/delete.machine.api";

export const useDeleteMachineApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => deleteMachineApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["all-machine-of-store"],
      });
    },
  });
};
